import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '',
    users = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.addUsers, {
        orgId,
        users,
    }, options);
    if (error) return { error, status };
    return content || {};
};
